import { defineStore, acceptHMRUpdate } from "pinia";

export const useMediaFilterStore = defineStore("mediaFilter", {
    state: () => {
        return {
            count: 0,
            year: [],
            venue: [],
            options: []
        };
    },
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useMediaFilterStore, import.meta.hot));
}
